import type { z } from "zod";
import { type LocalStorageAppRuleSchema, localStorageAppRuleSchema } from "~/data/defaultAppRules/types";
import { KeysEnum } from "./types";

const getAndParse = <T>(key: string, schema?: z.ZodType<T>): T | null => {
  const value = window.localStorage.getItem(key);

  if (value !== null) {
    try {
      // Try to parse the value with the schema if provided
      const jsonParsedValue = JSON.parse(value);
      return schema ? schema.parse(jsonParsedValue) : jsonParsedValue;
    } catch (_err) {
      // Remove the item if parsing fails and return null
      window.localStorage.removeItem(key);

      return null;
    }
  }

  return value;
};

const storage = {
  getAccessToken(): string | null {
    const item = window.localStorage.getItem(KeysEnum.OKTA_TOKEN_STORAGE);
    if (item) {
      const parsed = JSON.parse(item);
      return "accessToken" in parsed ? parsed.accessToken.accessToken : null;
    }
    return null;
  },

  getCreateDefaultAppRule: () => {
    return getAndParse(KeysEnum.CREATE_DEFAULT_APP_RULE, localStorageAppRuleSchema);
  },

  getSelectedOrgDocumentId() {
    return window.localStorage.getItem(KeysEnum.SELECTED_ORG_DOCUMENT_ID);
  },

  removeCreateDefaultAppRule: () => {
    window.localStorage.removeItem(KeysEnum.CREATE_DEFAULT_APP_RULE);
  },

  saveCreateDefaultAppRule: (value: LocalStorageAppRuleSchema) => {
    window.localStorage.setItem(KeysEnum.CREATE_DEFAULT_APP_RULE, JSON.stringify(value));
  },

  setSelectedOrgDocumentId(id: string) {
    window.localStorage.setItem(KeysEnum.SELECTED_ORG_DOCUMENT_ID, id);
  },
};

export default storage;
